// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal[data-v-64eb0bc3] .v--modal-box.v--modal {
  overflow: visible;
}
.custom-modal[data-v-64eb0bc3] .v--modal-box.v--modal .header {
  padding: 15px 20px 8px 15px;
}
.custom-modal[data-v-64eb0bc3] .v--modal-box.v--modal .body {
  overflow-y: visible;
  width: 100%;
}
.custom-modal[data-v-64eb0bc3] .v--modal-box.v--modal label.custom-checkbox {
  padding-left: 26px;
}
.custom-modal[data-v-64eb0bc3] .conf-type .custom-select-wrapper {
  width: 180px;
}
.custom-modal[data-v-64eb0bc3] .conf-item .wrapper {
  padding-top: 8px;
}
.newconference[data-v-64eb0bc3] {
  position: relative;
  color: var(--toolbtn-color);
  font-size: 16px;
  height: 210px;
  width: 100%;
  height: 100%;
  margin: 0 10px;
}
.newconference .conf-item[data-v-64eb0bc3] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
}
.newconference .custom-input-text[data-v-64eb0bc3] {
  width: 100%;
}
.newconference .custom-input-text[data-v-64eb0bc3] .non-border-input {
  width: 100%;
}
.newconference .custom-input-text-placeholder[data-v-64eb0bc3] {
  color: var(--modal-text-color) !important;
}
.newconference .conf-options[data-v-64eb0bc3] {
  flex-direction: column;
  align-items: flex-start;
  height: auto;
}
.newconference .conf-options form[data-v-64eb0bc3] {
  margin-top: 10px;
}
.newconference .conf-settings a[data-v-64eb0bc3] {
  color: var(--modal-elem-color);
  cursor: pointer;
}
.newconference .conf-settings a[data-v-64eb0bc3]:hover {
  color: var(--modal-elem-color);
  text-decoration: none;
}
.newconference .active-element[data-v-64eb0bc3] {
  transition: 0.5s;
}
.newconference .inactive-element[data-v-64eb0bc3] {
  transition: 0.5s;
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNewManagment/newConference.vue"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".custom-modal[data-v-64eb0bc3] .v--modal-box.v--modal {\n  overflow: visible;\n}\n.custom-modal[data-v-64eb0bc3] .v--modal-box.v--modal .header {\n  padding: 15px 20px 8px 15px;\n}\n.custom-modal[data-v-64eb0bc3] .v--modal-box.v--modal .body {\n  overflow-y: visible;\n  width: 100%;\n}\n.custom-modal[data-v-64eb0bc3] .v--modal-box.v--modal label.custom-checkbox {\n  padding-left: 26px;\n}\n.custom-modal[data-v-64eb0bc3] .conf-type .custom-select-wrapper {\n  width: 180px;\n}\n.custom-modal[data-v-64eb0bc3] .conf-item .wrapper {\n  padding-top: 8px;\n}\n.newconference[data-v-64eb0bc3] {\n  position: relative;\n  color: var(--toolbtn-color);\n  font-size: 16px;\n  height: 210px;\n  width: 100%;\n  height: 100%;\n  margin: 0 10px;\n}\n.newconference .conf-item[data-v-64eb0bc3] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 64px;\n}\n.newconference .custom-input-text[data-v-64eb0bc3] {\n  width: 100%;\n}\n.newconference .custom-input-text[data-v-64eb0bc3] .non-border-input {\n  width: 100%;\n}\n.newconference .custom-input-text-placeholder[data-v-64eb0bc3] {\n  color: var(--modal-text-color) !important;\n}\n.newconference .conf-options[data-v-64eb0bc3] {\n  flex-direction: column;\n  align-items: flex-start;\n  height: auto;\n}\n.newconference .conf-options form[data-v-64eb0bc3] {\n  margin-top: 10px;\n}\n.newconference .conf-settings a[data-v-64eb0bc3] {\n  color: var(--modal-elem-color);\n  cursor: pointer;\n}\n.newconference .conf-settings a[data-v-64eb0bc3]:hover {\n  color: var(--modal-elem-color);\n  text-decoration: none;\n}\n.newconference .active-element[data-v-64eb0bc3] {\n  transition: 0.5s;\n}\n.newconference .inactive-element[data-v-64eb0bc3] {\n  transition: 0.5s;\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
